export const FEATURE_FLAGS = {
  advisory: {
    enabled: 'common.enableAdvisoryCurrency',
    optOut: 'common.advisory.enableOptOut',
  },
  languageSelector: {
    enabled: 'common.enableLanguageSelector',
  },
};
